import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { addUnitOffer } from '../../services/unitOfferService';
import UnitOfferForm from '../unitOffer/UnitOfferForm';

function UnitOfferAdd(props) {
  const { id } = useParams();
  const [status, setStatus] = useState({ type: 'IDLE', message: 'Idle mode.' });

  const initialValues = {
    courseOfferId: id,
    unitCode: '',
    unitDescription: '',
    startDate: '',
    endDate: '',
    maxRegistrations: 0,
    minRegistrations: 0,
  };

  async function onSubmit(values) {
    let payload = {
      ...values,
      startDate: values.startDate.utc().format(),
      endDate: values.endDate.utc().format(),
    };

    if (validateDate(payload.startDate, payload.endDate)) {
      setStatus({ type: 'LOADING', message: 'Is waiting for response' });
      await addUnitOffer(payload)
        .then((res) => {
          setStatus({ type: 'SUCCESS', message: 'Succesful response' });
        })
        .catch((err) => {
          alert(err);
          setStatus({
            type: 'ERROR',
            message: 'Error/Fields should not be empty!',
          });
        });
    } else
      setStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!',
      });
  }

  function validateDate(startDate, endDate) {
    return new Date(startDate).getTime() < new Date(endDate).getTime();
  }

  return (
    <Modal
      title={`Add Unit Offer`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <UnitOfferForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          setStatus={setStatus}
          visible={props.isOpen}
          courses={props.courses}
        />
      )}
    </Modal>
  );
}

export default UnitOfferAdd;
